import React from 'react';

import Photo from '@travel/icons/ui/Photo';

import useDeviceType from '../../utils/useDeviceType';

import cx from '../../utils/classnames';

import styles from './galleryIcon.module.scss';

type Props = {
  /** Custom style for wrapper */
  className?: string;

  /** Number of gallery photos */
  photosCount: number;

  /** callback function when icon is clicked */
  onClick: () => void;

  /** Number to define icon size */
  iconSize?: number;
};

function GalleryIcon(props: Props) {
  const { className, photosCount, onClick, iconSize, ...rest } = props;
  const isMobile = useDeviceType() === 'sp';

  return (
    <button
      className={cx(className, styles.gallery)}
      onClick={onClick}
      data-testid="galleryIcon-openGallery-button"
      {...rest}
    >
      <span>{photosCount}</span>
      <Photo className={styles.photoIcon} color={'white'} size={iconSize || (isMobile ? 16 : 24)} />
    </button>
  );
}

GalleryIcon.defaultProps = {
  className: '',
  photosCount: 0,
  onClick: () => {},
};

export default GalleryIcon;
